import { AppId, FCX } from "@datassential/platform-ui-lib";
import './SectionConsumer.scss';
import FoodWidget from "@pages/Food/components/Widget/Widget";
import FoodSection from "@pages/Food/components/Section/Section";
import FoodAffinity from "@pages/Food/components/SectionConsumer/Affinity";
import { IFoodProfileConsumer } from "@models/FoodProfileConsumer";
import cn from "classnames";
import { PermissionLevelEnum } from "@models/PermissionSection";
import FoodExperience from "@pages/Food/components/SectionConsumer/Experience";
import FoodHeatScore from "@pages/Food/components/SectionConsumer/HeatScore";
import { useState } from "react";
import FoodTabs from "@pages/Food/components/Tabs/Tabs";
import FoodRespondentsData, { AnalyticsType } from "@pages/Food/components/SectionConsumer/RespondentsData";
import ExternalProductLink from "@pages/Food/components/ExternalProductLink/ExternalProductLink";
import PermissionOverlay from "@pages/Food/components/PermissionOverlay/PermissionOverlay";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { requestTrialByFeature } from "@actions/page";



const FoodSectionConsumer: FCX<{
    data: IFoodProfileConsumer;
}> = ({
    data: {
        data: {
            link,
            keywordName,
            loveLikeIt,
            knowIt,
            haveTriedIt,
            dataByDemoGroups,
            heatScore,
        },
        permissionLevel,
    }
}) => {
    const dispatch = useDispatch();
    const requestTrial: (f: string, hideNotification?: boolean) => any = (featureName, hideNotification) => {
        if (!hideNotification) {
            toast.info('Request has been sent');
        }
        return dispatch(requestTrialByFeature(featureName));
    };

    const [selectedAnalyticsType, setSelectedAnalyticsType] = useState<AnalyticsType>(AnalyticsType.Affinity);
    const hasAccess = permissionLevel !== PermissionLevelEnum.None;

    return (
        <FoodSection
            testId="blockFoodConsumer"
            headerContent={(
                <>
                    <div>CONSUMER</div>
                    <ExternalProductLink
                        appId={AppId.ConsumerPreferences}
                        link={link}
                        testId="buttonFoodConsumerExternalLink"
                    />
                </>
            )}
            className={cn(
                "FoodSectionConsumer appears-top del-4",
                !hasAccess && "is-blocked",
            )}
        >
            <div className="FoodSection__row">
                <div className="FoodSectionConsumer__col-1">
                    <div className="FoodSection__row">
                        <FoodWidget
                            testId="blockFoodConsumerAffinity"
                            headerContent={(
                                <div
                                    style={{ textAlign: "center", width: '100%'}}
                                    data-testid="textFoodConsumerAffinityTitle"
                                >
                                    AFFINITY
                                </div>
                            )}
                            className="FoodSectionConsumer__row-1 FoodSectionConsumer__widget-1-1"
                        >
                            <div className="FoodSectionConsumer__widget-1-1-content">
                                <FoodAffinity value={loveLikeIt}/>
                            </div>
                        </FoodWidget>
                        <FoodWidget
                            testId="blockFoodConsumerExperience"
                            headerContent={(
                                <div
                                    style={{ textAlign: "center", width: '100%'}}
                                    data-testid="textFoodConsumerExperienceTitle"
                                >
                                    EXPERIENCE
                                </div>
                            )}
                            className="FoodSectionConsumer__row-1 FoodSectionConsumer__widget-1-2"
                        >
                            <div className="FoodSectionConsumer__widget-1-2-content">
                                <FoodExperience knowItValue={knowIt} haveTriedItValue={haveTriedIt}/>
                            </div>
                        </FoodWidget>
                    </div>
                    <div className="FoodSection__row">
                        <FoodWidget
                            testId="blockFoodConsumerHeatScore"
                            headerContent={(
                                <div data-testid="textFoodConsumerHeatScoreTitle">
                                    HEAT SCORE
                                </div>
                            )}
                            className="FoodSectionConsumer__row-2 FoodSectionConsumer__widget-2-1"
                        >
                            <div className="FoodSectionConsumer__widget-2-1-content">
                                <FoodHeatScore
                                    keywordName={keywordName}
                                    data={heatScore}
                                />
                            </div>
                        </FoodWidget>
                    </div>
                </div>
                <FoodWidget
                    headerContent={(
                        <FoodTabs
                            data={[
                                { id: AnalyticsType.Affinity, title: 'Affinity' },
                                { id: AnalyticsType.Experience, title: 'Experience' },
                            ]}
                            activeTabId={selectedAnalyticsType}
                            onItemClick={(id) => setSelectedAnalyticsType(id as AnalyticsType)}
                            testId="blockFoodConsumerRespondentsHeaderTabs"
                        />
                    )}
                    className="FoodSectionConsumer__widget-3-1"
                >
                    <div className="FoodSectionConsumer__widget-3-1-content">
                        <FoodRespondentsData
                            selectedAnalyticsType={selectedAnalyticsType}
                            data={dataByDemoGroups}
                        />
                    </div>
                </FoodWidget>
            </div>
            {!hasAccess && (
                <PermissionOverlay
                    onContactUsClick={() => requestTrial('flavor')}
                    testId="blockFoodConsumerPermissionOverlay"
                >
                    <div data-testid="textFoodConsumerPermissionOverlayContentLine-0">
                        Upgrade your subscription to learn
                    </div>
                    <div data-testid="textFoodConsumerPermissionOverlayContentLine-1">
                        what consumers think of <b>{keywordName}</b>.
                    </div>
                </PermissionOverlay>
            )}
        </FoodSection>
    );
};

export default FoodSectionConsumer;